<template>
    <page-header-wrapper>
        <a-card :bordered="false">
            <!-- 条件搜索 -->
            <div class="table-page-search-wrapper">
                <a-form layout="inline" labelAlign="right">
                    <a-row :gutter="48">
                        <template>
                            <a-col :md="8" :sm="24">
                                <a-form-item label="联系人">
                                    <a-input
@keyup.enter="handleQuery"
v-model="queryParam.contacts"
placeholder="请输入"
                                        allow-clear />
                                </a-form-item>
                            </a-col>
                        </template>
                        <template>
                            <a-col :md="8" :sm="24">
                                <a-form-item label="联系电话">
                                    <a-input
@keyup.enter="handleQuery"
v-model="queryParam.mobile"
placeholder="请输入"
                                        allow-clear />
                                </a-form-item>
                            </a-col>
                        </template>
                        <template v-if="advanced">
                            <a-col :md="8" :sm="24">
                                <a-form-item label="状态">
                                    <a-select
@keyup.enter="handleQuery"
placeholder="请选择"
v-model="queryParam.status"
                                        style="width: 100%"
allow-clear>
                                        <a-select-option :value="0"> 正常 </a-select-option>
                                        <a-select-option :value="1"> 冻结 </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </template>

                        <a-col :md="(!advanced && 8) || 24" :sm="24">
                            <span
class="table-page-search-submitButtons"
                                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon
                                        type="redo" />重置</a-button>
                                <a @click="toggleAdvanced" style="margin-left: 8px">
                                    {{ advanced ? '收起' : '展开' }}
                                    <a-icon :type="advanced ? 'up' : 'down'" />
                                </a>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <div>
                <a-button type="primary" @click="handleChoose"> 确认选择 </a-button>
            </div>
            <a-table
:loading="loading"
:size="tableSize"
rowKey="id"
:columns="columns"
:data-source="list"
                :row-selection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :pagination="false"
:bordered="tableBordered">
                <span slot="status" slot-scope="text, record">
                    <!-- <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" /> -->
                    {{ record.status ? '冻结' : '正常' }}
                </span>
                <span slot="regionCount" slot-scope="text, record">
                    <a-button type="link" size="large" @click="handleLook(record, 2, 'system:qu:two')">
                        {{ record.statResult.regionCount }}
                    </a-button>
                </span>
                <span slot="tenantCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:jing:two')">
                    <a-button type="link" size="large">
                        {{ record.statResult.tenantCount }}
                    </a-button>
                </span>
                <span slot="waterCount" slot-scope="text, record" @click="handleLook(record, 6, 'system:shui:two')">
                    <a-button type="link" size="large" v-if="record.statResult">
                        {{ record.statResult.waterCount }}
                    </a-button>
                </span>
                <span slot="examinerCount" slot-scope="text, record" @click="handleLook(record, 5, 'system:yan:two')">
                    <a-button type="link" size="large" v-if="record.statResult">
                        {{ record.statResult.examinerCount }}
                    </a-button>
                </span>
                <span slot="devCount" slot-scope="text, record" @click="handleLook(record, 4, 'system:she:two')">
                    <a-button type="link" size="large" v-if="record.statResult">
                        {{ record.statResult.devCount }}
                    </a-button>
                </span>
                <span slot="orderCount" slot-scope="text, record" @click="handleLook(record, 8, 'system:ding:two')">
                    <a-button type="link" size="large" v-if="record.statResult">
                        {{ record.statResult.orderCount }}
                    </a-button>
                </span>
                <span slot="type" slot-scope="text, record">
                    {{ record.type == 1 ? '厂商' : '经销商' }}
                </span>
                <span slot="createTime" slot-scope="text, record">
                    {{ parseTime(record.createTime) }}
                </span>
                <span slot="operation" slot-scope="text, record">
                    <a
@click="$refs.createForm.handleUpdate(record, undefined)"
v-hasPermi="['system:tenant:edit']"
                        v-if="userTentant.tenantId == record.tenantId">
                        修改
                    </a>
                    <a-divider
type="vertical"
v-hasPermi="['system:tenant:query', 'system:tenant:frozen']"
                        v-if="userTentant.tenantId == record.tenantId" />
                    <a-dropdown v-hasPermi="['system:tenant:query', 'system:tenant:frozen']">
                        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                            <a-icon type="double-right" />
                            更多
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item v-hasPermi="['system:tenant:query']">
                                <a @click="handleDetail(record)" v-hasPermi="['system:tenant:query']"> 详情</a>
                            </a-menu-item>
                            <a-menu-item v-hasPermi="['system:tenant:query']">
                                <a @click="handleDelete(record)" v-hasPermi="['system:tenant:frozen']">
                                    {{ record.status == 0 ? '冻结' : '恢复' }}</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </span>
            </a-table>
            <!-- 分页 -->
            <a-pagination
class="ant-table-pagination"
show-size-changer
show-quick-jumper
:current="queryParam.pageNum"
                :total="total"
:page-size="queryParam.pageSize"
:showTotal="(total) => `共 ${total} 条`"
                @showSizeChange="onShowSizeChange"
@change="changeSize" />
        </a-card>
    </page-header-wrapper>
</template>
<script>
import { listTenant, frozenTenant } from '@/api/system/tenant'
import { regionList } from '@/api/pressure/region'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import setting from '@/locales/lang/zh-CN/setting'
import { mapGetters } from 'vuex'
export default {
    name: 'TenantTwo',
    components: {},
    prop: ['type'],
    mixins: [tableMixin],
    dicts: ['sys_enable_disable'],
    props: {
        firmId: {
            type: [String, Number],
        },
        tenantId: {
            type: [String, Number],
        },
    },
    data() {
        return {
            list: [],
            selectedRowKeys: [],
            userList: [],
            selectedRows: [],
            value: [],
            quList: [],
            visible: true,
            // 高级搜索 展开/关闭
            advanced: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            ids: [],
            loading: false,
            total: 0,
            queryParam: {
                pageNum: 1,
                pageSize: 10,
                type: 2,
                postCode: undefined,
                postName: undefined,
                status: undefined,
                firmId: undefined,
                regionId: undefined,
            },
            columns: [
                {
                    title: '经销商名称',
                    dataIndex: 'name',
                    width: '30%',
                    align: 'center',
                },
                {
                    title: '联系人',
                    dataIndex: 'contacts',
                    width: '30%',
                    ellipsis: true,
                    align: 'center',
                },
                {
                    title: '联系电话',
                    dataIndex: 'mobile',
                    width: '30%',
                    ellipsis: true,
                    align: 'center',
                },
                // {
                //   title: '区域数',
                //   dataIndex: 'statResult.regionCount',
                //   scopedSlots: { customRender: 'regionCount' },
                //   align: 'center',
                // },
                // {
                //   title: '分销商数',
                //   dataIndex: 'referredName3',
                //   align: 'center',
                // },

                // {
                //   title: '短信余额',
                //   dataIndex: 'smsBalance',
                //   align: 'center',
                // },
                // {
                //   title: '短信使用数',
                //   dataIndex: 'smsUse',
                //   align: 'center',
                // },
                // {
                //   title: '企业品牌类型',
                //   dataIndex: 'type',
                //   scopedSlots: { customRender: 'type' },
                //   align: 'center',
                // },
                // {
                //   title: '信用代码',
                //   dataIndex: 'socialCreditCode',
                //   align: 'center',
                // },
                // {
                //   title: '客服电话',
                //   dataIndex: 'customerMoblie',
                //   align: 'center',
                // },
                {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    width: 70,
                    align: 'center',
                },
                // {
                //   title: '营业状态',
                //   dataIndex: 'tradeStatus',
                //   scopedSlots: { customRender: 'tradeStatus' },
                //   align: 'center',
                // },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    ellipsis: true,
                    align: 'center',
                },
            ],
        }
    },
    filters: {},
    created() {
        console.log(this.type, 'typetypetypetype')
        if (!this.isOperate) {
            this.columns.pop()
        }
        // this.queryParam.firmId = this.firmId
        // this.queryParam.regionId = this.regionId
        // this.queryParam.tenantId = this.tenantId
        this.getList()

        console.log(this.userType, 'userType')
        console.log(this.regionId, 'regionIdregionIdregionId')

        // if (Number(this.userType) !== 2 && this.regionId) {
        //   this.getQu()
        // }
        console.log(this.userTentant, 'userTentant')
    },
    computed: {
        hasPermission() {
            return (permission) => {
                if (this.$store.state.user.userTentant.type === 0) {
                    return true
                } else {
                    return this.$store.state.user.permissions.includes(permission)
                }
                // return true
            }
        },
        userType() {
            return this.$store.state.user.userTentant.type
        },
        ...mapGetters(['userTentant']),
    },
    watch: {},
    methods: {
        handleChoose() {
            console.log(this.selectedRows, 'selectedRowKeys')
            this.$emit('changeAgent', this.selectedRows[0])
        },
        getQu() {
            regionList().then((res) => {
                console.log(res, '的点点滴滴')
                this.quList = res.data
            })
        },

        handleProvince(e) {
            this.queryParam.firmId = e
            this.$forceUpdate()
        },
        /** 查询经销商 */
        getList() {
            this.loading = true
            listTenant(this.queryParam).then((response) => {
                this.list = response.data.records
                this.total = response.data.total
                this.loading = false
                if (this.tenantId) { // 先判断是否传入了packageId
                    // 遍历表格数据，找到id与packageId匹配的行
                    const matchedRow = this.list.find(item => item.id === this.tenantId)
                    if (matchedRow) { // 找到匹配行时，设置选中状态
                        this.selectedRowKeys = [matchedRow.id] // 单选只需传入一个id数组
                        this.ids = [matchedRow.id] // 同步更新ids，确保后续操作（如确认选择）能拿到选中id
                        this.selectedRows = [matchedRow]
                    }
                }
            })
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        // 点击批量添加企业品牌
        handleUpload() {
            this.uploadAdd = true
            this.$nextTick(() => {
                this.$refs.uploadAdd.init(1)
            })
        },
        // 点击展示不同的页面信息
        handleLook(e, index, name) {
            if (!this.hasPermission(name)) return this.$message.error('暂无权限查看')
            if (!this.hasPermission(name)) return this.$message.error('暂无权限查看')
            this.$nextTick(() => {
                this.$refs.Detail.init(e, index)
            })
        },
        // 点击确定
        onChange(e) {
            console.log(e, '的点点滴滴')
            if (e.length) {
                this.queryParam.createBeginTime = moment(e[0]).format('YYYY-MM-DD')
                this.queryParam.createEndTime = moment(e[1]).format('YYYY-MM-DD')
            } else {
                this.queryParam.createBeginTime = ''
                this.queryParam.createEndTime = ''
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParam = {
                pageNum: 1,
                pageSize: 10,
                type: 1,
                postCode: undefined,
                postName: undefined,
                status: undefined,
            }
            this.value = []
            this.handleQuery()
            // setting
            // this
            this.$nextTick(() => {
                this.$refs.province.init()
            })
        },
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        handleChange(e) {
            console.log(e, '12121212')
            this.form.businessDays = e.sort((a, b) => a - b)
        },
        changeSize(current, pageSize) {
            this.queryParam.pageNum = current
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            this.ids = this.selectedRows.map((item) => item.id)
            this.single = selectedRowKeys.length !== 1
            this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            var that = this
            let ids = []
            const postIds = row.id || this.ids
            console.log(postIds, 'postIdspostIds')
            if (row.id) {
                ids = [{ id: postIds }]
            } else {
                postIds.forEach((v) => {
                    ids.push({ id: v })
                })
            }
            const text = row.status === 0 ? '是否确认冻结此用户' : '是否确认恢复此用户'
            this.$confirm({
                title: text,
                onOk() {
                    return frozenTenant(ids).then(() => {
                        that.onSelectChange([], [])
                        that.getList()
                        that.$message.success('冻结成功', 3)
                    })
                },
                onCancel() { },
            })
        },
        // 点击跳转详情
        handleDetail(record) {
            this.$nextTick(() => {
                this.$refs.Detail.init(record, 1)
            })
        },
        /** 导出按钮操作 */
        handleExport() {
            var that = this
            this.$confirm({
                title: '是否确认导出?',
                content: '此操作将导出当前条件下所有数据而非选中数据',
                onOk() {
                    that.download(
                        'system/tenant/export',
                        {
                            ...that.queryParam,
                        },
                        `企业品牌_${moment().format('YYYY-MM-DD')}.xlsx`
                    )
                },
                onCancel() { },
            })
        },
    },
}
</script>